import { memo } from "react";
import { View, Text } from "@src/components";

type ClipInfoHeaderProps = {
  hourRangeLabel: string;
  clipIndex: number;
  totalClips: number;
};

export const ClipInfoHeader = memo(({ hourRangeLabel, clipIndex, totalClips }: ClipInfoHeaderProps) => {
  return (
    <View flexDirection="row" justifyContent="space-between" alignItems="center" py="lg" gap="md" mb="md">
      {/* Duration of the clip (e.g. 2:00am - 3:00am) */}
      <Text textStyle="xs/semibold">{hourRangeLabel}</Text>
      {/* Clip ID as headline */}
      <Text textStyle="xxs/regular" color="textSecondary">
        Clip {clipIndex} of {totalClips}
      </Text>
    </View>
  );
});
